export const importMap: {
  [key: string]: {
    getComponent: () => Promise<{
      [key: string]: any;
    }>;
    eventListener?: string;
    skipInit?: boolean;
  };
} = {
  ProductListingPage: {
    getComponent: () => import("./components/ProductListingPage"),  
  },
  SearchModalResults: {
    getComponent: () => import("./components/SearchModalResults"),
    skipInit: true,
    eventListener: "load_search"
  },
  Wishlist: {
    getComponent: () => import("./components/Wishlist")
  },
  StackAndSave: {
    getComponent: () => import("./components/StackAndSave")
  },
  RecommendedProducts: {
    getComponent: () => import("./components/RecommendedProducts"), 
    skipInit: true,
    eventListener: "load_recommended_products"
  },
  ViewedProducts: {
    getComponent: () => import("./components/ViewedProducts"),
    skipInit: true,
    eventListener: "load_viewed_products"
  }, 
  BundleBuilder: {
    getComponent: () => import("./components/BundleBuilder")
  },
  QuizCollection: {
    getComponent: () => import("./components/QuizCollection")
  }
};
